import { API_BASE_URL } from '@shared/api';

/**
 * 회사 로고 값(`info_portfolio.company_logo`) → 그림 주소. be-migration 14절 "이미지(로고)":
 * - 새로 올린 키 `public/…` · 기존 서버 파일 `imgs/…`(앞에 `/` 가 붙은 값도 있다) → `GET /images/<key>`
 * - `/img/logo/…`(기존 웹의 정적 파일) · 절대 주소 · blob → 그대로(기존 정적 로고는 릴리스 1.2.0 expand 가 `public/logo/…` 로 옮긴다 — DD-49 #2 · DD-96)
 * 없으면 null(NoImage).
 */
export function logoSrc(value: string | null | undefined): string | null {
  if (!value) return null;
  if (/^(https?:|blob:|data:)/.test(value) || value.startsWith('/img/')) return value;
  const key = value.replace(/^\/+/, '');
  if (key.startsWith('imgs/') || key.startsWith('public/')) return `${API_BASE_URL}/images/${key}`;
  return value;
}
